import { Box, Button } from '@maas-components/core'
import { StoreOutlined } from '@maas-components/icons'
import { Link } from 'react-router-dom'
import { ERoutes } from 'common/entities/routes'
import i18n from 'common/i18n'

const UserInfoAction = () => {
  return (
    <Box display="flex" px={2} pb={2} justifyContent="center" alignItems="center">
      <Button
        component={Link}
        shape="circular"
        size="small"
        startIcon={<StoreOutlined />}
        to={ERoutes.HOME}
        variant="outlined"
      >
        {i18n.t('general.manageStore')}
      </Button>
    </Box>
  )
}

export default UserInfoAction
